import { CHANGE_CAREER_STATUS, DELETE_CAREER_USER, SET_CAREER_USER, CHANGE_CAREER_MEMBERSHIP, ADD_CAREER_USER, EDIT_CAREER_USER, CAREER_COURSE_UNENROLL } from "../constant";

export const deleteCareerUserById = (payload) => (
    {
        type: DELETE_CAREER_USER,
        payload: payload
    }
);

export const changeCareerStatus = (payload) => (
    {
        type: CHANGE_CAREER_STATUS,
        payload: payload
    }
);

export const changeCareerMemberShip = (payload) => (
    {
        type: CHANGE_CAREER_MEMBERSHIP,
        payload: payload
    }
);

export const setCareerUser = (payload) => (
    {
        type: SET_CAREER_USER,
        payload: payload
    }
);

export const addCareerUser = (payload) => (
    {
        type: ADD_CAREER_USER,
        payload: payload
    }
);

export const editCareerUser = (payload) => (
    {
        type: EDIT_CAREER_USER,
        payload: payload
    }
);

export const CareerCourseUnenroll = (payload) => (
    {
        type: CAREER_COURSE_UNENROLL,
        payload: payload
    }
);